export const onDragStart = (
  src: string,
  alt: string,
  e: {
    dataTransfer: { dropEffect: string; effectAllowed: string };
  }
) => {
  let dt: any = e.dataTransfer;

  // Custom mimetype format
  dt.setData("image/jpeg", src);

  // Best practice according to docs
  dt.setData("text/uri-list", src);

  // Another format which is often mentioned on how-tos (but not docs)
  dt.setData("text/html", `<img src="${src}" title="${alt}" alt="${alt}"/>`);

  dt.setData("application/vnd.apple.numbers", src);

  // Default "ol' reliable"
  dt.setData("text/plain", src);

  e.dataTransfer.dropEffect = "copy";
  e.dataTransfer.effectAllowed = "all";
};

